// AI Deep wire trim — what the client sends per 15s bin (pure, no Angular; gemini.service.ts calls it).
// tools/bench/bench-deep.mjs imports the compiled module too, so the bench sends exactly what the
// app sends. Server side: cloud-run-api/lib/deep.js buildDeepInput.
import type { ActivityBin } from '../models/twitch.model';
import { isChatBot } from './chat-bots.js';

export const DEEP_SAMPLE_PER_BIN = 10;

export interface DeepBin {
  startTime: number;
  messageCount: number;   // messages of the whole bin, bots excluded
  messages: string[];     // ≤10 "Nick: text", spread evenly over the bin
  authorCount: number;    // distinct authors of the whole bin, bots excluded
}

/** "Nick: text" → nick ('' when there's no separator). */
export function chatAuthor(m: string): string {
  const k = m.indexOf(': ');
  return k > 0 ? m.slice(0, k) : '';
}

/**
 * xQc-tier chats have peak bins of 1500+ messages — ~10MB of JSON the server would discard, so only
 * the 10 it shows the model go out. They're spread over the whole bin (the first 10 were its first
 * second). `authorCount` = distinct authors of the WHOLE bin: the server tells the model how many
 * different people wrote — a burst from two or three viewers arguing used to look like a crowd
 * reacting. Bots are left out of the sample, the authors AND the count (else «12 сообщ. · 1 автор»
 * over two lines reads as one viewer spamming).
 */
export function trimBinsForDeep(bins: ReadonlyArray<ActivityBin>): DeepBin[] {
  return bins.map(b => {
    const all = b.messages;
    const human = all.filter(m => !isChatBot(chatAuthor(m)));
    const n = human.length;
    const messages = n <= DEEP_SAMPLE_PER_BIN
      ? human
      : Array.from({ length: DEEP_SAMPLE_PER_BIN }, (_, i) => human[Math.floor((i * n) / DEEP_SAMPLE_PER_BIN)]);
    const authors = new Set<string>();
    for (const m of human) {
      const a = chatAuthor(m);
      if (a) authors.add(a.toLowerCase());
    }
    return { startTime: b.startTime, messageCount: Math.max(0, b.messageCount - (all.length - n)), messages, authorCount: authors.size };
  });
}
